export default __webpack_public_path__ + "static/media/femimed_recepcja.dc217b62.webp";